import { alert } from "@components/common/Alert";
import { DSButton } from "@components/design-system/molecules";
import { faWindowRestore } from "@fortawesome/pro-solid-svg-icons";
import { Tooltip } from "@mui/material";
import { useEffect, useEffectEvent, useRef } from "react";
import { useSearchParams } from "react-router";

export const OpenPipButton = ({ pipUrl }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const deepLinkConsumedRef = useRef(false);

  const openPip = async () => {
    const pipWindow =
      await window.documentPictureInPicture.requestWindow({
        disallowReturnToOpener: true,
        width: 320,
        height: 600,
      });

    const styleNode = pipWindow.document.createElement("style");
    styleNode.innerHTML = `
      html, body, iframe {
        width: 100%;
        height: 100%;
        margin: 0;
        padding: 0;
      }
      iframe {
        display: block;
        border: none;
      }
    `;
    pipWindow.document.head.appendChild(styleNode);

    const iframe = document.createElement("iframe");
    iframe.src = pipUrl;
    pipWindow.document.body.appendChild(iframe);

    iframe.contentWindow.addEventListener(
      "message",
      (evt) => {
        if (evt.data.returnToTab) {
          window.focus();
          pipWindow.close();
        }
      },
      false,
    );
  };

  const triggerOpenPip = useEffectEvent(() => {
    if (!pipUrl) return;
    if (!window.documentPictureInPicture) {
      alert(
        "error",
        "Widget Mode isn't supported in this browser. Try the latest Chrome or Edge.",
      );
      return;
    }
    openPip().catch(() => {
      alert(
        "error",
        "Couldn't open Widget Mode. Try clicking the Widget Mode button.",
      );
    });
  });

  useEffect(() => {
    if (deepLinkConsumedRef.current) return;
    if (searchParams.get("tab") !== "widgetMode") return;
    deepLinkConsumedRef.current = true;

    const newParams = new URLSearchParams(searchParams);
    newParams.delete("tab");
    setSearchParams(newParams, { replace: true });
    // defer so PiP open runs after React commits setSearchParams (avoids work-loop reentry)
    queueMicrotask(triggerOpenPip);
  }, [searchParams, setSearchParams]);

  if (!window.documentPictureInPicture) {
    return null;
  }

  return (
    <Tooltip
      arrow
      placement="bottom"
      title="Widget Mode allows you to access Scribenote features more easily side-by-side with your PIMS/medical records."
    >
      <div className="relative">
        <DSButton
          variant="secondary"
          size="sm"
          icon={faWindowRestore}
          onClick={openPip}
          data-mx-label="pip-open"
          dataTestId="pip-open-button"
        >
          Widget Mode
        </DSButton>
      </div>
    </Tooltip>
  );
};
